<template>
  <a :class="['btn', `btn--${customClass}`]" :href="href">{{ text }}</a>
</template>

<script>
export default {
  name: 'BaseBtn',
  props: {
    text: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    href: {
      type: String
    }
  }
}
</script>

<style lang="scss">
.btn {
  font-family: $OpenSans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  text-decoration: none;

  &--default {
    @include easeOut;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 46px;
    padding: 0 30px;
    min-width: 180px;
    border-radius: 24px;
    background-color: #ff0022;
    box-sizing: border-box;

    &:hover {
      background-color: #d90022;
    }
  }

  &--default-text {
    @include easeOut;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 46px;
    padding: 0 30px;
    min-width: 180px;
    color: #ff0022;
    border: 1px solid #ff0022;
    border-radius: 24px;
    box-sizing: border-box;

    &:hover {
      border-width: 2px;
    }
  }
}

@include media-min($tablet-width) {
  .btn {
    &--default {
      min-width: 158px;
      max-width: initial;
      margin: 0 auto;
      padding: 0 20px;
    }
  }
}

@include media-min($desktop-width) {
  .btn {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseDowloadBtn.vue